import { useState, useEffect } from "react";

/**
 * Returns a debounced version of the given value. Updates after delayMs of the value staying stable.
 * @param {*} value - Current value (any type)
 * @param {number} delayMs - Debounce delay in milliseconds
 * @returns {*} - The value after the delay has passed without change
 */
function useDebouncedValue(value, delayMs) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);

  return debounced;
}

export default useDebouncedValue;
